"use client";
import emailjs from "@emailjs/browser";
import { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

emailjs.init({ publicKey: "dEsW42iLGgJ_LHF5d" });

const ContactForm = () => {
  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    number: "",
    message: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    let newErrors = {};

    // First Name
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First Name is required";
    } else if (!/^[A-Za-z]+$/.test(formData.firstName.trim())) {
      newErrors.firstName = "First Name should contain only letters";
    }

    // Last Name (required + only letters)
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last Name is required";
    } else if (!/^[A-Za-z]+$/.test(formData.lastName.trim())) {
      newErrors.lastName = "Last Name should contain only letters";
    }

    // Email
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      newErrors.email = "Invalid email format";
    }

    // Phone Number
    if (!formData.number.trim()) {
      newErrors.number = "Number is required";
    } else if (!/^[0-9]{10}$/.test(formData.number.trim())) {
      newErrors.number = "Number must be 10 digits";
    }

    // Project Description
    if (!formData.message.trim()) {
      newErrors.message = "Project description is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Description must be at least 10 characters";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      if (isSubmitting) return;
      setIsSubmitting(true);

      emailjs
        .send("service_40gwxsi", "template_pbspwsv", formData)
        .then(() => {
          toast.success("Form submitted successfully!", {
            toastId: "form-success",
          });
          setFormData(initialState);
          setErrors({});
        })
        .catch((error) => {
          toast.error("Something went wrong. Please try again.", {
            toastId: "form-error",
          });
          console.error("EmailJS Error:", error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  return (
    <div id="contact" className="relative z-20 w-full">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="flex flex-col sm:flex-row sm:gap-5 gap-3">
          {/* First Name */}
          <div className="w-full">
            <label className="text-base font-normal text-darkBlack pb-2 inline-block">
              First Name
            </label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={(e) =>
                setFormData({ ...formData, firstName: e.target.value })
              }
              className="w-full border border-offGrey px-3 py-3.5 bg-white sm:px-4 rounded-lg text-base max-sm:text-sm hover:border-[#FF5858] outline-none"
            />
            {errors.firstName && (
              <p className="text-red-500 text-base">{errors.firstName}</p>
            )}
          </div>

          {/* Last Name */}
          <div className="w-full">
            <label className="text-base font-normal text-darkBlack pb-2 inline-block">
              Last Name
            </label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={(e) =>
                setFormData({ ...formData, lastName: e.target.value })
              }
              className="w-full border border-offGrey px-3 py-3.5 bg-white sm:px-4 rounded-lg text-base max-sm:text-sm hover:border-[#FF5858] outline-none"
            />
            {errors.lastName && (
              <p className="text-red-500 text-base">{errors.lastName}</p>
            )}
          </div>
        </div>

        {/* Email & Phone */}
        <div className="flex flex-col sm:flex-row sm:gap-5 gap-3">
          <div className="w-full">
            <label className="text-base font-normal text-darkBlack pb-2 inline-block">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              className="w-full border border-offGrey px-3 py-3.5 bg-white sm:px-4 rounded-lg text-base max-sm:text-sm hover:border-[#FF5858] outline-none"
            />
            {errors.email && (
              <p className="text-red-500 text-base">{errors.email}</p>
            )}
          </div>

          <div className="w-full">
            <label className="text-base font-normal text-darkBlack pb-2 inline-block">
              Phone Number
            </label>
            <input
              type="text"
              name="number"
              value={formData.number}
              onChange={(e) =>
                setFormData({ ...formData, number: e.target.value })
              }
              className="w-full border border-offGrey px-3 py-3.5 bg-white sm:px-4 rounded-lg text-base max-sm:text-sm hover:border-[#FF5858] outline-none"
            />
            {errors.number && (
              <p className="text-red-500 text-base">{errors.number}</p>
            )}
          </div>
        </div>

        {/* Project Description */}
        <div>
          <label className="text-base font-normal text-darkBlack pb-2 inline-block">
            Project Description
          </label>
          <textarea
            name="message"
            placeholder="Your Message"
            rows={4}
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
            className="w-full border border-offGrey px-3 py-2.5 sm:py-3 bg-white sm:px-4 rounded-lg text-base max-sm:text-sm hover:border-[#FF5858] outline-none h-[151px]"
          />
          {errors.message && (
            <p className="text-red-500 text-base">{errors.message}</p>
          )}
        </div>

        <div className="flex gap-3 items-center">
          <input type="checkbox" className=" w-4 h-4 sm:h-6 sm:w-6"/>
          <p className="text-[#424242] max-sm:text-sm opacity-80 ">
            I agree to terms of services and privacy policy
          </p>
        </div>

        {/* Submit Button */}
        <div className="text-center ">
          <button
            type="submit"
            disabled={isSubmitting}
            className="lg:py-4 w-full group relative py-3 lg:px-7 px-5 rounded-full bg-[#FF5858] border border-[#FF5858] cursor-pointer font-medium after:absolute after:left-0 after:w-0 hover:after:w-full after:z-[0] after:top-0 after:rounded-full after:h-full after:bg-white overflow-hidden after:transition-all after:duration-300 after:ease-in-out transition-all duration-300 mt-8"
          >
            <span className="z-10 relative group-hover:text-[#FF5858] text-white">
              {isSubmitting ? "Submitting..." : "Submit"}
            </span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
